import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { specialties } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'specialties', element: <ModuleLayout />,
    handle: { title: i18n.t('specialties.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'specialties:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('specialties.new'), permission: 'specialties:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => specialties.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (country: any) => (country && i18n.t('specialties.edit', country)), permission: 'specialties:update' },
      },
    ],
  },
];
